import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/utils';

// MD3 tonal pill. `secondary` is the literal "tonal pill (secondary-container
// bg)" the spec calls for; the other variants reuse the same low-opacity-tonal
// language — a good fit for status pills in a dense card grid. Card-specific
// semantic colors (condition NM/LP/MP/HP/DM) stay in index.css's .badge-nm
// etc. classes for now — they're independent of the MD3/neon theme swap, not
// something this primitive needs to absorb.
const badgeVariants = cva(
  'inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap transition-colors [&>svg]:size-3 [&>svg]:pointer-events-none',
  {
    variants: {
      variant: {
        default: 'bg-primary/12 text-primary',
        secondary: 'bg-secondary text-secondary-foreground',
        tertiary: 'bg-tertiary/12 text-tertiary',
        destructive: 'bg-destructive/12 text-destructive',
        outline: 'border border-outline text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({
  className,
  variant,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return (
    <span
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
